module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<span id="channel-' +
__e(id) +
'" class="slot-col">\n    <span class="slot-name"></span>\n    <div class="channel-tooltip" style="display:none">\n        <div><strong>CSS Selector</strong>: <span class="selector"></span></div>\n        <div><strong>Url</strong>: <span class="url"></span></div>\n        <div><strong>Potential domain match</strong>: <span class="matches"></span></div>\n        <div><strong>Last updated</strong>: <span class="editedat"></span></div>\n    </div>\n</span>\n<span class="live-now-col">\n    <span class="live"></span>\n</span>\n<span class="live-next-col">\n    <span class="next"></span>\n</span>\n<span class="live-date-col">\n    <span class="live-date"></span>\n</span>\n<span class="slot-options-col">\n    <div class="actions-panel">\n        ';
 if (showChannelActionsPanel) { ;
__p += '\n            ';
 if (!allowedToPublish) { ;
__p += '\n                <span class="delete pull-right disabled" data-content="You do not have permission to delete Slots"></span>\n            ';
 } else { ;
__p += '\n                <span class="delete pull-right" data-content="Delete Slot"></span>\n            ';
 } ;
__p += '\n\n            ';
 if (!allowedToPublish) { ;
__p += '\n                <span class="detach pull-right disabled" data-content="You do not have permission to detach Slots"></span>\n            ';
 } else if (isLocked) { ;
__p += '\n                <span class="no-detach pull-right" data-content="The Slot contains an Experience or Group from the current Project and cannot be detached"></span>\n            ';
 } else { ;
__p += '\n                <span class="detach pull-right" data-content="Detach Slot"></span>\n            ';
 } ;
__p += '\n        ';
 } ;
__p += '\n    </div>\n</span>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/projects/publish/ProjectChannelSetupItemView.tpl
// module id = 1245
// module chunks = 0